import type { ApplicationLicenseStates } from '@jira/platform__license-state/src/license-state.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

export const useLicenseStates = (): ApplicationLicenseStates => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.licenseStates;
};
